import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { ClasseProfitComponent } from './classeProfit/classe-profit.component';
import { FormmapaComponent } from './formmapa/formmapa.component';
import { Step1CommonComponent } from './steps/step1/step1common.component';
import { Step2CommonComponent } from './steps/step2/step2common.component';
import { TypeAdresseComponent } from './typeAdresse/type-adresse.component';
import { TypeAdresseCompleteObligatoireComponent } from './typeAdresseCompleteObligatoire/type-adresse-complete-obligatoire.component';
import { TypeAdresseTEMPOSTComponent } from './typeAdresseTEMPOST/type-adresseTEMPOST.component';
import { TypeCoordComponent } from './typeCoord/type-coord.component';
import { TypeMotsClefComponent } from './typeMotsClef/type-mots-clef.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { TypePersComponent } from './typePers/type-pers.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';

@NgModule({
  declarations: [
    TypeCoordComponent,
    TypePersComponent,
    TypeAdresseComponent,
    TypeAdresseCompleteObligatoireComponent,
    ClasseProfitComponent,
    TypeOuiNonComponent,
    TypeVoieComponent,
    TypeAdresseTEMPOSTComponent,
    TypeMotsClefComponent,
    Step1CommonComponent,
    Step2CommonComponent,
    FormmapaComponent,
  ],
  exports: [
    Step1CommonComponent,
    Step2CommonComponent,
    FormmapaComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
})
export class FormmapaCommonModule {}
